<div class="header">
<h2>Inserisci la tua email:</h2>
<p>A breve riceverai un'email con il link per procedere al cambio password.</p>
</div>



<form [formGroup]="form" (ngSubmit)="submit()">
  <p class="label">Email: *</p>
  <mat-form-field appearance="outline">
    <input matInput formControlName="username" type="email" />
    <mat-error *ngIf="form.get('email')?.hasError('required')">Email richiesta</mat-error>
    <mat-error *ngIf="form.get('email')?.hasError('email')">Email non valida</mat-error>
  </mat-form-field>

<div class="actions">
  <button mat-stroked-button type="button" (click)="cancel()">Annulla</button>
  <button mat-flat-button color="primary" type="submit">Conferma</button>
</div>

</form>
